import { render, staticRenderFns } from "./DonateHomeLayout.vue?vue&type=template&id=60b6319a&scoped=true&"
import script from "./DonateHomeLayout.vue?vue&type=script&lang=js&"
export * from "./DonateHomeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b6319a",
  null
  
)

export default component.exports